const allVideoPlayers = Array.from(document.getElementsByTagName('video'));

const toggleVideoPlayState = (videoId) => {
    const videoContainer = document.getElementById(videoId);
    const video = videoContainer.querySelector('.video-module');
    const pause = videoContainer.querySelector('.video-module-controls-pause');
    const play = videoContainer.querySelector('.video-module-controls-play');

    if (video.paused) {
      video.play();
      pause.classList.add('video-module-controls--active');
      play.classList.remove('video-module-controls--active');
    } else {
      video.pause();
      play.classList.add('video-module-controls--active');
      pause.classList.remove('video-module-controls--active');
    }
}

function onVisible(element,elementIndex) {
  new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if(!(entry.intersectionRatio > 0)) {
        element.pause();
      } else {
        element.play();
      }
    });
  }).observe(element);
}

//when player is in view, play the video, otherwise stop it
setTimeout(() => {
  
  allVideoPlayers.forEach((video, elementIndex) => {
    onVisible(video,elementIndex);
  });
  
}, 100);








